package com.findyourbuddies.website.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement

@Composable
fun SocialIcon(
    url: String,
    backgroundColor: CSSColorValue,
    icon: String
) {
    A(
        href = url,
        attrs = {
            target(ATarget.Blank)
            style {
                textDecoration("none")
            }
        }
    ) {
        Box(
            modifier = Modifier
                .size(40.px)
                .backgroundColor(backgroundColor)
                .borderRadius(50.percent)
                .margin(8.px)
                .cursor(Cursor.Pointer),
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                icon,
                modifier = Modifier
                    .color(Colors.White)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Bold)
            )
        }
    }
}

@Composable
fun SocialLinks() {
    Row(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText(
            "Follow us on :",
            modifier = Modifier
                .fontSize(12.px)
                .color(Colors.White)
                .margin(right = 1.em)
                .fontFamily("Comfortaa", "Arial", "sans-serif")
        )

        SocialButtons()
    }
}

@Composable
fun SocialButtons() {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            gap(12.px)
            justifyContent(JustifyContent.Center)
        }
    }) {
        SocialButton(
            href = "https://www.facebook.com/toncompte",
            backgroundCss = "linear-gradient(180deg, #1877F2 0%, #1659d9 100%)"
        ) {
            Svg(attrs = {
                attr("viewBox", "0 0 24 24")
                attr("width", "18")
                attr("height", "18")
                attr("fill", "white")
            }) {
                Path(attrs = {
                    attr(
                        "d",
                        "M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07c0 4.99 3.66 9.13 8.44 9.92v-7.02H8.1v-2.9h2.34V9.4c0-2.31 1.38-3.59 3.5-3.59.99 0 1.82.07 2.07.1v2.4h-1.42c-1.12 0-1.34.67-1.34 1.31v1.73h2.72l-.44 2.9h-2.28V22C18.34 21.2 22 17.06 22 12.07z"
                    )
                })
            }
        }

        SocialButton(
            href = "https://www.instagram.com/findyourbuddies_freediving/",
            backgroundCss = "linear-gradient(45deg, #f58529 0%, #dd2a7b 50%, #8134af 100%)"
        ) {
            Svg(attrs = {
                attr("viewBox", "0 0 24 24")
                attr("width", "18")
                attr("height", "18")
                attr("fill", "white")
            }) {
                Path(attrs = {
                    attr(
                        "d",
                        "M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm4.75-.75a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                    )
                })
            }
        }
    }
}

@Composable
fun SocialButton(href: String, backgroundCss: String, content: @Composable () -> Unit) {
    A(href, attrs = {
        attr("target", "_blank")
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            width(30.px)
            height(30.px)
            borderRadius(50.percent)
            property("background", backgroundCss)
            cursor("pointer")
            property("transition", "transform 0.12s ease, box-shadow 0.12s ease")
            margin(8.px)
        }
        onMouseOver { (it.target as? HTMLElement)?.style?.setProperty("transform", "scale(1.08)") }
        onMouseOut { (it.target as? HTMLElement)?.style?.setProperty("transform", "scale(1)") }
    }) {
        content()
    }
}

@Composable
fun SocialButton(href: String, svgContent: @Composable () -> Unit) {
    A(href, attrs = {
        attr("target", "_blank")
    }) {
        Div(attrs = {
            style {
                width(48.px)
                height(48.px)
                borderRadius(50.percent)
                backgroundColor(Color("white"))
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
                cursor("pointer")
                margin(8.px)
                property("box-shadow", "0 4px 8px rgba(0,0,0,0.2)")
                property("transition", "transform 0.2s")
            }
            onMouseOver {
                (it.target as? HTMLElement)?.style?.setProperty("transform", "scale(1.1)")
            }
            onMouseOut {
                (it.target as? HTMLElement)?.style?.setProperty("transform", "scale(1)")
            }
        }) {
            svgContent()
        }
    }
}
